import useUserBookReadService from "services/UserBookReadService/useUserBookReadService";
import CurrentlyReadingCardContent from "./CurrentlyReadingCardContent/CurrentlyReadingCardContent";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import useUserBookService from "services/UserBookService/useUserBookService";
import { LetterbooksSerializersBook, UserBookSerializersUserBook } from "types/serializers";
import { toast } from "sonner";
import { router } from "@inertiajs/react";

export default function CurrentlyReadingCard({
  userBook: initialUserBook,
  book,
}: {
  userBook: UserBookSerializersUserBook;
  book: LetterbooksSerializersBook;
}) {
  const initialUserBookRead = initialUserBook.datesRead[initialUserBook.datesRead.length - 1];
  const currentUserId = useCurrentUserId();
  const { userBook, insertDateRead } = useUserBookService(book.id);
  const { userBookRead, updateProgress, setUserBookReadId } = useUserBookReadService({ bookId: book.id, userBookReadId: initialUserBookRead?.id });
  const isOwner = initialUserBook?.userId === currentUserId;

  function trackRead() {
    insertDateRead().then(
      (newUserBookRead) => {
        if (newUserBookRead) {
          setUserBookReadId(newUserBookRead.id);
          toast.success("Now tracking progress for this book");
        }
      }
    );
  };

  if(isOwner && !userBook) {
    router.reload();
    return false;
  }

  // Pass in dynamic options for the owner
  return (
    <CurrentlyReadingCardContent
      book={book}
      edition={isOwner ? userBookRead?.edition || userBook.edition : initialUserBookRead?.edition || initialUserBook.edition}
      isOwner={isOwner}
      userBook={isOwner ? userBook : initialUserBook}
      userBookRead={isOwner ? userBookRead : initialUserBookRead}
      onProgressChange={updateProgress}
      trackRead={trackRead}
    />
  );
}
